document.addEventListener('DOMContentLoaded', function () {
  const pills = document.querySelectorAll('#accessoires-pills .pill');
  // On cible uniquement les produits de la liste principale (évite d'impacter les carrousels)
  const mainList = document.querySelector('.accessories-products-list');
  const products = mainList ? mainList.querySelectorAll('.bigpharma-product') : [];
  let currentCategory = null;

  pills.forEach(pill => {
    pill.addEventListener('click', function () {
      pills.forEach(p => p.classList.remove('active'));
      const cat = this.dataset.category;

      // Pill "Tous" : reset
      if (cat === 'Tous') {
        currentCategory = null;
        this.classList.add('active');
        products.forEach(prod => prod.style.display = '');
        return;
      }

      // Si on clique à nouveau sur la même pill, reset
      if (currentCategory === cat) {
        currentCategory = null;
        products.forEach(prod => prod.style.display = '');
        return;
      }

      this.classList.add('active');
      currentCategory = cat;

      products.forEach(prod => {
        // On récupère le champ gamme (dans un élément avec la classe .bigpharma-product--gamme-item)
        const gammeItems = Array.from(prod.querySelectorAll('.bigpharma-product--gamme-item')).map(x => x.textContent.trim());
        // Affiche si la gamme contient la catégorie sélectionnée
        if (gammeItems.some(gamme => gamme.toLowerCase() === currentCategory.toLowerCase())) {
          prod.style.display = '';
        } else {
          prod.style.display = 'none';
        }
      });
    });
  });

  // Recherche dynamique Accessoires
  const searchInput = document.getElementById('accessoires-filter-name');
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      const query = searchInput.value.trim().toLowerCase();
      let pillActive = document.querySelector('#accessoires-pills .pill.active');
      let cat = pillActive ? pillActive.dataset.category : null;

      products.forEach(prod => {
        // Nom du produit
        const name = prod.querySelector('.bigpharma-product--title')?.textContent?.toLowerCase() || '';
        // Badges
        const gammeItems = Array.from(prod.querySelectorAll('.bigpharma-product--gamme-item')).map(x => x.textContent.trim().toLowerCase());

        // Filtrage catégorie (si une pill autre que "Tous" est active)
        let matchCategory = true;
        if (cat && cat !== 'Tous') {
          matchCategory = gammeItems.some(gamme => gamme === cat.toLowerCase());
        }

        // Filtrage recherche (nom ou badge)
        let matchSearch = !query || name.includes(query) || gammeItems.some(gamme => gamme.includes(query));

        // Affichage si ET logique
        if (matchCategory && matchSearch) {
          prod.style.display = '';
        } else {
          prod.style.display = 'none';
        }
      });
    });
  }

  // Par défaut, active la pill "Tous"
  const pillTous = document.querySelector('#accessoires-pills .pill[data-category="Tous"]');
  if (pillTous) pillTous.classList.add('active');
});
